/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type CartItems_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartLayout_viewer$ref: FragmentReference;
export type CartLayout_viewer = {|
  +userRelationships: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +displayName?: ?string,
      +phoneNumber?: ?string,
      +email?: ?string,
    |}>
  |}>,
  +$fragmentRefs: CartItems_viewer$ref,
  +$refType: CartLayout_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]!"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "CartItems_viewer",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "userRelationships",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "relationshipType",
          "value": "VIP",
          "type": "relationshipType!"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "userIds",
          "type": "[String]!"
        }
      ],
      "concreteType": "UserRelationship",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "userDataB",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "VipRepData",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "displayName",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "phoneNumber",
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "formatType",
                      "value": "INTERNATIONAL",
                      "type": "formatPhoneNumberTypes"
                    }
                  ],
                  "storageKey": "phoneNumber(formatType:\"INTERNATIONAL\")"
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "email",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '47ede3d845c5a3a4d1f976450047a5d2';
module.exports = node;
